module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-col', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "filterable": "",
      "placeholder": "请输入/选择小程序名称"
    },
    on: {
      "clear": function($event) {
        return _vm.clear('issued_app_id')
      }
    },
    model: {
      value: (_vm.chooseProduct.name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "name", $$v)
      },
      expression: "chooseProduct.name"
    }
  }, _vm._l((_vm.IssAppList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id,
        "default-first-option": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.changeProduct(item)
        }
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "size": "small",
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择对应公司/渠道"
    },
    on: {
      "clear": function($event) {
        return _vm.clear('channel_id')
      }
    },
    model: {
      value: (_vm.pdata.channel_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "channel_id", $$v)
      },
      expression: "pdata.channel_id"
    }
  }, _vm._l((_vm.companys_chiannelList), function(item, index) {
    return _c('el-option', {
      key: item.channel_id,
      attrs: {
        "label": item.company + '-' + item.ald_channel,
        "value": item.channel_id
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "size": "small",
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择操作人员"
    },
    on: {
      "clear": function($event) {
        return _vm.clear('uid')
      }
    },
    model: {
      value: (_vm.pdata.uid),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "uid", $$v)
      },
      expression: "pdata.uid"
    }
  }, [(_vm.pdata.uid == '') ? _c('el-option', {
    key: "",
    attrs: {
      "label": "请选择操作人员",
      "value": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.users), function(item, index) {
    return _c('el-option', {
      key: item.uid,
      attrs: {
        "label": item.username,
        "value": item.uid
      }
    })
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "row-key": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "游戏名称",
      "align": "center",
      "width": "125px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "对应公司",
      "align": "center",
      "width": "125px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ald_channel",
      "label": "渠道名称",
      "align": "center",
      "width": "125px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "操作时间",
      "align": "center",
      "min-width": "185px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘",
      "align": "center",
      "min-width": "185px"
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d0e2903"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/log/costLog.vue
// module id = 1138
// module chunks = 2